var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.375 25C22.5527 25 26.75 20.8027 26.75 15.625C26.75 10.4473 22.5527 6.25 17.375 6.25C12.1973 6.25 8 10.4473 8 15.625C8 20.8027 12.1973 25 17.375 25Z",
    fill: "#0A38D9",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96863 31.2499C5.61121 29.2922 7.66264 27.718 9.97873 26.6379C12.2948 25.5579 14.8193 24.9982 17.3749 24.9982C19.9304 24.9982 22.4549 25.5579 24.771 26.6379C27.0871 27.718 29.1385 29.2922 30.7811 31.2499",
    fill: "#0A38D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96863 31.2499C5.61121 29.2922 7.66264 27.718 9.97873 26.6379C12.2948 25.5579 14.8193 24.9982 17.3749 24.9982C19.9304 24.9982 22.4549 25.5579 24.771 26.6379C27.0871 27.718 29.1385 29.2922 30.7811 31.2499H3.96863Z",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 23.75C36.2557 23.75 37.375 22.6307 37.375 21.25C37.375 19.8693 36.2557 18.75 34.875 18.75C33.4943 18.75 32.375 19.8693 32.375 21.25C32.375 22.6307 33.4943 23.75 34.875 23.75Z",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 18.75V16.875",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7032 20L31.0939 19.0625",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7032 22.5L31.0939 23.4375",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.875 23.75V25.625",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0469 22.5L38.6563 23.4375",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0469 20L38.6563 19.0625",
    stroke: "#0A38D9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminFill);
export default __webpack_public_path__ + "static/media/admin-fill.1bcdd6c7a7313e4eced5ff0bddd84f8a.svg";
export { ForwardRef as ReactComponent };